import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

const basic = 'Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=',
  autho = '';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        Authorization: basic,
        
      },
    });
    return next.handle(request);
  }
}





// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/token-interceptor.ts